import { FC } from 'react';
import SVGIconsInterface from '../interface/SVGIcons';
import Home from './Home';
import Signin from './Signin';
import Listing from './Listing';
import Podcasts from './Podcasts';
import Videos from './Videos';
import Tags from './Tags';
import FAQ from './FAQ';
import About from './About';
import Contact from './Contact';
import DEVShop from './DEVShop';
import Sponser from './Sponser';
import CodeOfConduct from './CodeOfConduct';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import Love from './Love';
import Comment from './Comment';
import DEVLogo from './DEVLogo';
import Location from './Location';
import Joined from './Joined';
import Email from './Email';
import Github from './Github';
import Lens from './Lens';
import Close from './Close';
import Bookmark from './Bookmark';
import Unicorn from './Unicorn';
import Like from './Like';
import FilledLike from './FilledLike';
import Maximize from './Maximize';
import ReadingList from './ReadingList';
import FilledBookmark from './FilledBookmark';

const SVGIcons: SVGIconsInterface = {
  Home,
  Signin,
  Listing,
  Podcasts,
  Videos,
  Tags,
  FAQ,
  About,
  Contact,
  DEVShop,
  Sponser,
  CodeOfConduct,
  PrivacyPolicy,
  TermsOfUse,
  Love,
  Comment,
  DEVLogo,
  Location,
  Joined,
  Email,
  Github,
  Lens,
  Close,
  Like,
  FilledLike,
  Unicorn,
  Bookmark,
  Maximize,
  ReadingList,
  FilledBookmark,
};

export default SVGIcons;
